import type { Character } from '../domain/character.ts';
import type { Skill } from '../content/types.ts';
import type { ContentRegistry } from '../content/registry.ts';
import { attacksFor } from './attackService.ts';

/**
 * Builds the Attack-tab choices that come from the crawler's actual possessions.
 *
 * The attack engine deliberately does not inspect Item -> Attack links. That
 * relationship belongs to inventory/equipment composition. A crawler may still
 * attempt the matching Attack untrained: this helper exposes the Skill at Rank 0
 * when a physical weapon they own links to it, while `attackService` remains
 * responsible only for planning and resolving the Attack itself.
 */
export function attackChoicesForOwnedWeapons(
  character: Character,
  registry: ContentRegistry,
): Skill[] {
  const byId = new Map(attacksFor(character, registry).map((skill) => [skill.id, skill]));

  for (const owned of character.inventory) {
    if (owned.quantity < 1) continue;
    const item = registry.getItem(owned.itemId);
    const linkedAttackId = item?.weaponAttackId ?? null;
    if (linkedAttackId === null || registry.getAttack(linkedAttackId) === undefined) continue;
    const skill = registry.getSkill(linkedAttackId);
    if (skill) byId.set(skill.id, skill);
  }

  return [...byId.values()].sort((a, b) => a.name.localeCompare(b.name));
}
